import { useEffect, useState } from 'react';

export const useProcessReportGenerateButtonState = <T>(entities: T[]) => {
    const [disableGenerateButton, setDisableGenerateButton] = useState<boolean>(true);

    useEffect(() => {
        if(entities.length === 0) {
            setDisableGenerateButton(true);
        } else {
            setDisableGenerateButton(false);
        }
    }, [entities.length]);

    return { disableGenerateButton };
};
